import React, { useEffect, useState } from "react";
import db from "../../db/index.json";
import ParagraphTag from "../reusebale/Paragraph";
import { LogIn } from "lucide-react";
import { useSelector, useDispatch } from "react-redux"
import BaseUrl from "../../constants/BaseUrl"
import * as DataAction from "../../store/actions/data/DataAction"
import { Link, useNavigate } from "react-router-dom";
import { ShowError, ShowSuccess } from "../../utils/ToasFunction";
import MyLoader from "../reusebale/myLoader";
const PrevShiftStatus = ({ onBack }) => {


  const navigate = useNavigate();
  const { support } = db;
  const { currentShift } = useSelector(
    (state) => state.data
  );
  const dispatch = useDispatch()


  const sessionIdPastShift = useSelector((state) => state.data.sessionIdPastShift)





  function GetTimeDifference(checkInDate) {
    const checkIn = new Date(checkInDate);
    const now = new Date();

    let diffMs = Math.abs(now - checkIn); // Get absolute difference in milliseconds
    let diffMinutes = Math.floor(diffMs / (1000 * 60)); // Convert to minutes
    let hours = Math.floor(diffMinutes / 60);
    let minutes = diffMinutes % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  }


  function FormatCheckInDate(checkInData) {
    const date = new Date(checkInData);


    const optionsDate = { day: '2-digit', month: 'short' };
    const formattedDate = date.toLocaleDateString('en-GB', optionsDate);


    const optionsTime = { hour: 'numeric', minute: '2-digit', hour12: true };
    const formattedTime = date.toLocaleTimeString('en-US', optionsTime);

    return `${formattedDate} ${formattedTime}`;
  }

  const [loading, setLoadig] = useState(false)

  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );

  const [sessionDetails, setSessiondetails] = useState()

  const GeetShiftDetails = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
      
    };

    fetch(`${BaseUrl}api/support/getShiftDetailsBySessionId/${sessionIdPastShift}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setSessiondetails(result.data)
        }
      })
      .catch((error) => console.error(error));
  }

  useEffect(() => {
    GeetShiftDetails()
  }, [])



  return (
    <div className="bg-white rounded-xl p-5">
      <ParagraphTag
        content="CHECK IN / CHECK OUT"
        classes="text-darkColor font-popinsSemiBold text-lg"
      />


      {/* Timeline Wrapper */}
      <div className="relative pt-5 flex flex-col items-start pl-6">
        {/* Vertical Line (Passes Through Center) */}
        <div className="absolute left-[6px] top-0 bottom-0 w-[2px] bg-gray-400"></div>

        {/* Check-In */}
        <div className="relative flex items-center pb-3">
          {/* Bullet */}
          <div className="absolute left-[-6px] w-3 h-3 bg-themeColor rounded-full"></div>
          <ParagraphTag
            content="Check In - "
            classes="text-darkColor/70 font-popinsMedium text-base pl-4"
          />
          <ParagraphTag
            content={sessionDetails?.checkInDate ? FormatCheckInDate(sessionDetails?.checkInDate) : "N/A"}
            classes="text-darkColor/40 font-popinsMedium text-xs pl-1"
          />
        </div>

        {/* Check-Out */}
        <div className="relative flex items-center">
          {/* Bullet */}
          <div className="absolute left-[-6px] w-3 h-3 bg-red-400 rounded-full"></div>
          <ParagraphTag
            content="Check Out - "
            classes="text-darkColor/70 font-popinsMedium text-base pl-4"
          />
          <ParagraphTag
            content="N/A"
            classes="text-darkColor/40 font-popinsMedium text-xs pl-1"
          />
        </div>
      </div>

      <div className="flex items-center pt-4">
        <ParagraphTag
          content={sessionDetails?.checkInDate ? GetTimeDifference(sessionDetails?.checkInDate) : "0"}
          classes="text-darkColor font-popinsSemiBold text-xl"
        />
        <ParagraphTag
          content="Total hours"
          classes="text-darkColor/50 font-popinsMedium text-sm pl-2"
        />
      </div>

    </div>
  );
};

export default PrevShiftStatus;
